<mat-card class="mat-elevation-z8">
        <form [formGroup]="block_register_form">
            <!-- user details -->
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Block Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                        <input type="text" class="form-control code_box" formControlName='name'>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label for="exampleFormControlSelect1">District</label>
                        <select class="form-control dropdown_box" formControlName='district_id'>
                            <option *ngFor="let district of districts" [value]="district['id']">{{district['name']}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="registerBlock()"
                [disabled]="!block_register_form.valid">{{action}}</button>
        </form>
    </mat-card>
